





















import DateHourRange from '@/classes/DateHourRange'

import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api'
import { useCounter, useIntersectionObserver } from '@vueuse/core'
import PricedCar from '@/classes/PricedCar'
import Store from '@/classes/Store'
import dataLayer, { DataLayer } from '@/modules/data-layer'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    list: {
      type: Array as PropType<PricedCar[]>,
      default: [],
    },
    infiniteScroll: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Object as PropType<DateHourRange | null>,
      default: null,
    },
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    // 列表尾端的元素
    const end = ref<Element>()
    // 要顯示的項目數量
    const { count, inc, set, reset } = useCounter(10)
    const loadMore = () => inc(10)
    const isAllLoaded = computed(() => count.value > Number(props.list?.length))
    useIntersectionObserver(end, () => {
      if (!isAllLoaded.value) loadMore()
    }, { threshold: 0 })

    // 列表變動時重置要顯示的數量
    watch(() => props.list, () => reset())
    watch(() => props.infiniteScroll, (value) => {
      if (value) reset()
      else set(Infinity)
    }, { immediate: true })

    // 前 n 個項目列表
    const partialList = computed(() => {
      if (props.list) return props.list?.slice(0, count.value)
      else return []
    })

    watch(partialList, (newList, oldList) => {
      let initialLength = 0
      if (oldList) initialLength = oldList.length

      if (!newList?.length) return

      const productArr = []

      for (let i = initialLength; i < newList.length; i++) {
        const car = newList[i]
        const store = props.store

        if (store) {
          productArr.push(DataLayer.GogooutCarToEcommerceItem(car, store))
        }
      }

      dataLayer.viewItemList({
        items: productArr,
      })
    })

    return {
      end,
      partialList,
      loadMore,
      isAllLoaded,
    }
  },
})
